import { useState } from 'react';
import { textToImage, textToImageStatus } from "@/api/apiMethods.js";
import { imgToVideo, imgToVideoStatus } from "@/api/apiMethods.js";
import aibg from '@/assets/ai/texttoimg/aibg.mp4';
import ailoading from '@/assets/ai/texttoimg/ailoading.mp4';
import aijdt from '@/assets/ai/texttoimg/jdt.mp4';
import aiinput from '@/assets/ai/texttoimg/aiinput.png';
import appaiinput from '@/assets/ai/texttoimg/appaiinput.png';
import fenge from '@/assets/ai/texttoimg/fenge.png';
import aishow from '@/assets/ai/texttoimg/aishow.png';
import aino from '@/assets/ai/texttoimg/aino.png';
import aiyes from '@/assets/ai/texttoimg/aiyes.png';
import aileft from '@/assets/ai/texttoimg/aileft.png';
import airight from '@/assets/ai/texttoimg/airight.png';
import appassets from '@/assets/ai/texttoimg/appassets.png';
import appassets1 from '@/assets/ai/texttoimg/appassets1.png';
import appassets2 from '@/assets/ai/texttoimg/appassets2.png';
import { ethers } from 'ethers';
import ChatgptComponent from "@/components/Chatgpt/Chatgpt.jsx";
import { useAccount } from 'wagmi';
import './index.css'
function Ai() {
    const { address, isConnected } = useAccount();
    const [description, setDescription] = useState('');
    const [videoDescription, setVideoDescription] = useState('');
    const [greetingMessage, setgreetingMessage] = useState(`AI’s in. Your move. Let’s play smarter.`);
    const [modelId, setModelId] = useState('flux');
    const [negativePrompt, setNegativePrompt] = useState('nsfw,worst quality,low quality,monochrome,bad hand,deformity,bad legs,error legs,bad feet,malformed limbs,ugly,poorly drawn hands,poorly drawn feet,poorly drawn face,extra fingers,mutated hands,mutation,disfigured,fused fingers');
    const [imgWidth, setImgWidth] = useState(1000);
    const [imgHeight, setImgHeight] = useState(600);
    const [enhancePrompt, setEnhancePrompt] = useState('yes');
    const [enhanceStyle, setEnhanceStyle] = useState('game-cyberpunk');
    const [imgSeed, setImgSeed] = useState(-1);
    const [guidanceScale, setGuidanceScale] = useState(10);
    const [tomesd, setTomesd] = useState('yes');
    const [useKarrasSigmas, setUseKarrasSigmas] = useState('yes');
    const [ImgVae, setImgVae] = useState('');
    const [loraStrength, setLoraStrength] = useState('');
    const [loraModel, setLoraModel] = useState('');
    const [selfAttention, setSelfAttention] = useState('yes');
    const [clipSkip, setClipSkip] = useState(2);
    const [highresFix, setHighresFix] = useState('no');

    const [imageUrl, setImageUrl] = useState('');
    const [videoUrl, setVideoUrl] = useState('');
    const [message, setMessage] = useState('');
    const [vmessage, setvMessage] = useState('');
    const [desc, setdesc] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [radioStates, setRadioStates] = useState({
        EnhancePrompt: 'yes',
        tomesd: 'yes',
        useKarrasSigmas: 'yes',
        selfAttention: 'yes',
        highresFix: 'no',
    });
    const contractAddress = "0xd452C58fF65B5465312Dad01729EcC87c73B57fa";
    const contractABI = [
        "function mint() external"
    ];
    const handleInputChange = (e) => {
        setDescription(e.target.value);
        setMessage('');
    };
    const setIsTextAreaActive = () => {
        setgreetingMessage('The wilder, the better! Just type, and let’s bring your ideas to life!');
    };

    const handleVideoInputChange = (e) => {
        setVideoDescription(e.target.value);
        setvMessage('');
    };

    const handleGenerateImage = async (e) => {
        if (!description) {
            setMessage('The input cannot be empty, please enter a description of the picture');
            return;
        }
        if (description && e == 'web') {
            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth'
            });
        }
        setIsLoading(true);
        try {
            const res = await textToImage({
                // model_id: modelId,
                prompt: `(${description}:1.15)，wearing complex high-tech armor, blue and purple complex technology shape, wearing technology virtual VR glasses, the space is transparent and clear, high saturation background. High definition detail retention, advanced picture texture.From a distance, the super-detailed description of the dark night scene, a night stroll after the rain in the super-large futuristic neon tech cyberpunk style city, with virtual sci-fi projections and fantasy neon frames,`,
            });

            setdesc(res);
            if (res) {
                setImageUrl(res.image);
                setIsLoading(false);
                const messages = [
                    'Asset generated! Looking good. You’ve got your own game asset now.',
                    'Your asset is ready! Looks great, it’s all yours now.',
                    'The asset is ready! Awesome work, you’ve got your own game asset.',
                    'Game asset generated! Everything looks perfect, now it’s yours!'
                ];
                const randomMessage = messages[Math.floor(Math.random() * messages.length)];
                setgreetingMessage(randomMessage);
            }
        } catch (error) {
            console.error('Error occurred:', error);
            setIsLoading(false);
        }
    };

    const handleRadioChange = (e, field) => {
        setRadioStates(prevState => ({
            ...prevState,
            [field]: e.target.value,
        }));

        if (field === 'enhancePrompt') {
            setEnhancePrompt(e.target.value);
        } else if (field === 'selfAttention') {
            setSelfAttention(e.target.value);
        }
    };


    // 生成视频
    const handleGenerateVideo = async () => {
        // if (!videoDescription) {
        //     setvMessage('The input cannot be empty, please enter a description of the picture');
        //     return;
        // }
        setIsLoading(true);
        try {
            const response = await imgToVideo({
                promptImage: imageUrl,
                promptText: videoDescription ? videoDescription : 'The neon lights of the city in the background flicker with light particle effects, and the wind blows through the character, causing the character\'s hair and clothes to flutter.',  // 生成视频时的描述文字
                duration: 5
            });
            console.log(response);
            if (response) {
                const videoInter = setInterval(async () => {
                    const videoStatus = await imgToVideoStatus({
                        id: response.id,
                    });
                    console.log(videoStatus, 'videoStatus');
                    if (videoStatus.status === 'SUCCEEDED') {
                        console.log(videoStatus, 'videoStatus');
                        setVideoUrl(videoStatus.output[0]);
                        clearInterval(videoInter);
                        setIsLoading(false);
                    }
                }, 5000);
            }
        } catch (e) {
            console.log(e.message);
        }
    };



    const handleMint = async () => {
        if (!window.ethereum) {
            alert("Please install the MetaMask extension!");
            return;
        }
        try {
            setgreetingMessage('The user asset agreement is being loaded, please wait');
            await window.ethereum.request({ method: "eth_requestAccounts" });
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const signer = provider.getSigner();
            const contract = new ethers.Contract(contractAddress, contractABI, signer);
            const tx = await contract.mint();
            await tx.wait();

            setgreetingMessage(`The agreement has come into effect and the user's assets have been transferred successfully`);
        } catch (error) {
            console.error("Mint failed:", error);
            setgreetingMessage(`Change detected, user asset transfer protocol has been terminated`);
        }

    };

    return (
        <div className="bg-black h-screen text-white relative font-silkscreen">
            {/* new web */}
            <div className='sm:block hidden'>
                <div className="w-full h-3xl text-white  relative">
                    {/* <img src={aibg} alt="" className='w-full h-full ' /> */}
                    <video className=" w-screen h-full" loop autoPlay muted>
                        <source src={aibg} type="video/mp4" />
                    </video>
                    <div className="w-full absolute bottom-[90px] left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-center font-poppins text-xl font-bold leading-normal">
                        I am BP-1,designed to turn imagination into reality. <br />
                        Every world starts with a vision, and I am here to transform yours into a tangible game asset.<br />
                        Tell me your story, and together, we will bring it to life.
                    </div>
                </div>
                <div className="bg-black w-full h-[200px] text-white flex items-center justify-center">
                    <div className='w-[1328px] h-[300px] rounded-lg border-[3px] border-[#4449f0] bg-[#121168] mb-3 mt-8 p-2 relative bottom-[90px] left-0'>
                        <img src={aiinput} alt="" style={{ transform: 'scaleX(-1)' }} />
                        <textarea
                            className="absolute top-[85px] left-[670px] transform -translate-x-1/2 -translate-y-1/2 w-[1278px] h-[130px] p-2 rounded bg-[#020318] resize-none border-none outline-none font-silkscreen text-xl"
                            placeholder="Type your message..."
                            value={description}
                            onChange={handleInputChange}
                            onFocus={() => setIsTextAreaActive()}
                            rows="4"
                            cols="30"
                        ></textarea>
                        <div className='absolute top-[180px] left-[10px] w-[177px] h-[75px] bg-[#3633F7] flex items-center justify-center  rounded-lg text-white font-poppins text-[26.537px] font-bold uppercase cursor-pointer transform transition duration-150 ease-in-out active:scale-95' onClick={() => handleGenerateImage('web')} disabled={isLoading} >GENERATE</div>
                        <p className='text-[#909090] text-lg w-[1079px] ml-48 mt-1'>The more vivid your description, the closer we get to your vision.
                            Try something like: A cybernetic detective with glowing red eyes and a trench coat or A biomechanical dragon with neon circuitry.
                            Your creativity is the key—describe boldly!</p>
                    </div>
                </div>
                <div className="bg-black w-full h-[600px] text-white relative">
                    <img src={fenge} alt="" className='w-full relative top-[6px] z-[3]' />
                    <div className='flex flex-col items-center relative z-[2]'>
                        <img src={aishow} alt="" className='w-[1327.86px] h-[428.36px]' />
                    </div>
                    <div className='w-[1250.86px] h-[348.92px] absolute top-[105px] left-0 right-0 mx-auto flex justify-between z-[2]'>
                        <div className='w-[264.73px] h-[348.92px] ml-1'>
                            {!isLoading && !imageUrl && (
                                <video className="w-screen h-full" muted>
                                    <source src={ailoading} type="video/mp4" />
                                </video>

                            )}
                            {isLoading ? (
                                <div className="relative">
                                    <video className="w-screen h-full" loop autoPlay muted>
                                        <source src={ailoading} type="video/mp4" />
                                    </video>
                                    <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white text-xl font-bold  flex">
                                        GENERATING<span className="dots"></span>
                                    </div>
                                    <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 text-white text-xl font-bold" style={{ height: '20px', width: '258px' }}>
                                        <video className="w-full h-full" autoPlay muted>
                                            <source src={aijdt} type="video/mp4" />
                                        </video>
                                    </div>

                                </div>

                            ) : imageUrl ? (
                                <div className='w-[264.73px] h-[348.92px] relative'>
                                    <img src={`data:image/png;base64,${imageUrl}`} alt="" className='w-full h-full object-cover' />
                                    <div
                                        className="w-[169px] h-[51px] flex items-center justify-center text-[37px] absolute bottom-[-80px] left-1/2 transform -translate-x-1/2 bg-[#383ef3] text-white py-2 px-6 rounded-lg cursor-pointer transition duration-150 ease-in-out active:scale-95"
                                        onClick={handleMint}
                                    >
                                        Mint
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className='w-[264.73px] h-[348.92px] relative'>
                            <img src={aino} alt="" className='w-full h-full object-cover' />
                            <p className='w-[201px] text-center absolute bottom-0 left-1/2 transform -translate-x-1/2 text-white font-poppins text-3xl font-bold'>
                                coming soon <br />......
                            </p>
                        </div>

                        <div className='w-[264.73px] h-[348.92px] mr-2 relative'>
                            <img src={aino} alt="" className='w-full h-full object-cover' />
                            <p className='w-[201px] text-center absolute bottom-0 left-1/2 transform -translate-x-1/2 text-white font-poppins text-3xl font-bold'>
                                coming soon <br />......
                            </p>
                        </div>
                    </div>
                    <img src={aileft} alt="" className='w-[306px] h-[312.31px] absolute bottom-16 left-0 z-[1]' />
                    <img src={airight} alt="" className='w-[507px] h-[517.45px] absolute bottom-0 right-0 z-[1]' />
                </div>
                <ChatgptComponent greetingMessage={greetingMessage} />
            </div>
            {/* new app*/}
            <div className='sm:hidden block'>
                <div className="w-full h-3xl text-white  relative">
                    <video className=" w-screen h-full" loop autoPlay muted playsInline
                        // eslint-disable-next-line react/no-unknown-property
                        webkit-playsinline="true">
                        <source src={aibg} type="video/mp4" />
                    </video>
                </div>

                <div className="bg-black w-full text-white flex items-center justify-center p-2">
                    <div className='w-[23.3125rem] h-full rounded-lg border-[3px] border-[#4449f0] bg-[#121168] mb-3 p-2'>
                        <p className='text-base'>
                            I am BP-1,and I will help you create your own
                            unique game cartriidge.
                            In this cyberpunk world, the protagonist may be a mercenary, a couriera business elite, or even a non-human.
                            Please use your imagination and tell me what kind of image youwant the protagonist of this game to be.
                        </p>
                        <div className="mt-3">
                            <div className='relative'>
                                <img src={appaiinput} alt="" style={{ transform: 'scaleX(-1)' }} />
                                <textarea
                                    className="w-[20rem] h-[15rem] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[55%] p-2 bg-[#020318] resize-none border-none outline-none font-silkscreen text-xl"
                                    placeholder="Type your message..."
                                    value={description}
                                    onChange={handleInputChange}
                                    onFocus={() => setIsTextAreaActive()}
                                ></textarea>
                                <div className='flex justify-center items-center -mt-3'>
                                    <div
                                        className='text-lg w-[225px] h-[37px] bg-[#3633F7] flex items-center justify-center text-white font-poppins text-[26.537px] font-bold uppercase cursor-pointer transform transition duration-150 ease-in-out active:scale-95 rounded-[2.25px]'
                                        onClick={() => handleGenerateImage('app')}
                                        disabled={isLoading}
                                    >
                                        GENERATE
                                    </div>
                                </div>
                            </div>

                            <div className=' mt-2 text-center text-[15px] text-[#909090]'>
                                Note: A specific description will help me understand you better. For exanmple (a killer who looks like Keanu Reeves wearing high-tech equipment), (a modified mouse riding a high-tech warhorse), etc.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full h-3xl bg-black">
                    <div className='w-full h-full flex flex-col items-center justify-center relative'>
                        <img src={appassets} alt="" className="relative" />
                        <div className='w-[264.73px] h-[348.92px]  absolute inset-0 m-auto top-[70px] p-2'>
                            {!isLoading && !imageUrl && (
                                <video className="w-screen h-full" muted>
                                    <source src={ailoading} type="video/mp4" />
                                </video>

                            )}
                            {isLoading ? (
                                <div className="relative">
                                    <video className="w-screen h-full" loop autoPlay muted playsInline
                                        // eslint-disable-next-line react/no-unknown-property
                                        webkit-playsinline="true">
                                        <source src={ailoading} type="video/mp4" />
                                    </video>
                                    <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white text-xl font-bold  flex">
                                        GENERATING<span className="dots"></span>
                                    </div>
                                    <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 text-white text-xl font-bold" style={{ height: '20px', width: '258px' }}>
                                        <video className="w-full h-full" autoPlay muted playsInline
                                            // eslint-disable-next-line react/no-unknown-property
                                            webkit-playsinline="true">
                                            <source src={aijdt} type="video/mp4" />
                                        </video>
                                    </div>

                                </div>

                            ) : imageUrl ? (
                                <div className='w-[264.73px] h-[348.92px] relative'>
                                    <img src={`data:image/png;base64,${imageUrl}`} alt="" className='w-full h-full object-cover' />
                                    {/* <div
                                        className="w-[169px] h-[51px] flex items-center justify-center text-[37px] absolute bottom-[-80px] left-1/2 transform -translate-x-1/2 bg-[#383ef3] text-white py-2 px-6 rounded-lg cursor-pointer transition duration-150 ease-in-out active:scale-95"
                                        onClick={handleMint}
                                    >
                                        Mint
                                    </div> */}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className='w-full h-full mt-2'>
                        <img src={appassets1} alt="" />
                    </div>
                    <div className='w-full h-full mt-2'>
                        <img src={appassets2} alt="" />
                    </div>
                </div>
            </div>
            <ChatgptComponent greetingMessage={greetingMessage} />
        </div>

    );
}

export default Ai;
